module.exports = __webpack_public_path__ + "static/media/Rank_Medal.3c135b2e.svg";